<template>
  <a-layout-footer class="layout-footer">
    <div class="copyright">
      版权所有 ©
      <span>广州城市可持续发展研究会</span>
    </div>
  </a-layout-footer>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style lang="scss" scoped>
  .layout-footer {
    text-align: center;
    user-select: none;
    background-color: transparent;
  }

  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
</style>
